import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';

const QUERY = gql`
  query PerformanceCenterCampaigns(
    $accountId: ID!
    $customerId: ID!
    $dataSource: PerformanceCenterDataSource!
  ) {
    performanceCenterRequest(
      accountId: $accountId
      customerId: $customerId
      dataSource: $dataSource
    ) {
      id
      campaigns {
        id
        name
        copyCount
      }
    }
  }
`;

export const queryPerformanceCenterCampaigns = (accountId, customerId, dataSource) => {
  return executeGqlQuery({
    query: QUERY,
    variables: { accountId, customerId, dataSource },
  })
    .then(({ data }) => getSingleProp(data))
    .then((result) => {
      return result?.performanceCenterTextVariationsRequest;
    });
};
